import { Assert } from '@aura/core-lib';
import configEstacio from './estacio';
import configIbmec from './ibmec';
import configIdomed from './idomed';
import { Environment } from './types';
import configWyden from './wyden';

const environments: Array<() => Environment> = [
  configEstacio.prod,
  configIbmec.prod,
  configWyden.prod,
  configIdomed.prod,
  configEstacio.local,
  configIbmec.local,
  configWyden.local,
  configIdomed.local,
  configEstacio.browserStack,
  configEstacio.dev,
  configIbmec.dev,
  configWyden.dev,
  configIdomed.dev,
  configEstacio.hml,
  configIbmec.hml,
  configWyden.hml,
  configIdomed.hml,
];

export const getConfig = (): Environment => {
  const contextoAtual = `${window.location.protocol}//${window.location.host}`;
  const env = environments.map((env) => env()).find((env) => env.contextos.some((ctx) => ctx.host === contextoAtual));

  Assert.nonNullable(env);

  return env;
};
